import * as React from 'react';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RouterProps, withRouter } from 'react-router';
import { State } from '../../redux/state';
import { LProps, withLocalization } from '../../utils/wrappers';
import { Entity, Competition, CompetitionEntityScore } from '../../userApi';
import { makeSimpleRoutePath, Routes, makeEntityPath } from '../../utils/routerHelper';
import ScoreboardTeams from '../../shared/ScoreboardTeams';
import { teamScoresForUserUniversity, userTeam, userUniversity } from '../../redux/selectors';
import actions from '../../redux/actions';
import { ErrorNoTeamsForUniversity } from '../../shared/Errors';
import { asPage } from '../../utils/wrappers/asPage';
import { Button } from 'reactstrap';
import Footer from '../../shared/Footer';
import * as selectors from '../../redux/selectors';
import { teamLabelFor, teamsLabelFor, teamCreationDisabled, departmentDivisionFromEntity } from '../../utils/competitionLabels';

interface Props {
  university: Entity;
  team: Entity;
  competition: Competition;
  teamScores: CompetitionEntityScore[];
  hasCompetitionEnded: boolean;
  initializeTeamsPage: () => void;
}

class TeamsPage extends React.Component<LProps<Props> & RouterProps> {

  public componentWillMount() {
    const { initializeTeamsPage } = this.props;
    initializeTeamsPage();
  }

  public render() {
    const {
      team, t, competition, teamScores, history, hasCompetitionEnded
    } = this.props;
    const teamLabel = teamLabelFor(competition, t('Team'));
    const teamsLabel = teamsLabelFor(competition, t('Teams'));
    const creationDisabled = teamCreationDisabled(competition);
    const teamDisplay = team ? (departmentDivisionFromEntity(team).division || team.name) : '';
    return (
      <div id="cc__teams" className="cc__page__column_content">
        <div className="cc__page__column_content__left">
          {team &&
            <div>
              <h4>{`Your ${teamLabel}`}</h4>
              <Link to={makeEntityPath(competition.id, team, t)}>{teamDisplay}</Link>
            </div>
          }
          {(!team && !hasCompetitionEnded && !creationDisabled) &&
            <div className="cc__teams__no_team">
              <h2>{`No ${teamLabel.toLowerCase()} yet?`}</h2>
              <Button
                color="primary"
                onClick={() => history.push(makeSimpleRoutePath(Routes.TeamsNew, t))}
              >{`Create a ${teamLabel.toLowerCase()}`}</Button>
              <p className="cc__lighttext cc__bigtext">
                {`Or choose from one of the featured ${teamsLabel.toLowerCase()} or from the entire list to contribute your points.`}
              </p>
            </div>
          }
          {(!team && !hasCompetitionEnded && creationDisabled) &&
            <div className="cc__teams__no_team">
              <h2>{`Choose your ${teamLabel}`}</h2>
              <p className="cc__lighttext cc__bigtext">
                {`Select your ${teamLabel.toLowerCase()} from the participating list during signup, or ask an admin for help.`}
              </p>
            </div>
          }
          <Footer />
        </div>
        <div className="cc__page__column_content__right">
          <div className="cc__white_box">
            <h3 className="cc__darktext" style={{ marginBottom: '0.75rem' }}>{`${teamLabel} leaderboard`}</h3>
            {teamScores.length === 0 && <ErrorNoTeamsForUniversity t={t} competition={competition} />}
            {teamScores.length > 0 &&
              <div className="cc__scoreboard">
                <ScoreboardTeams teamScores={teamScores} />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, _ownProps: LProps<RouterProps>): Partial<Props> => ({
  teamScores: teamScoresForUserUniversity(state),
  competition: state.competition,
  team: userTeam(state),
  university: userUniversity(state),
  hasCompetitionEnded: selectors.hasCompetitionEnded(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  initializeTeamsPage: actions.initializeTeamsPage
}, dispatch);

export default asPage({})(compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withLocalization('teams')
)(TeamsPage));
